module.exports = __webpack_public_path__ + "8d22e28bf2a2d78d156bfd27430a767c.svg";